import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { ToolbarEvent } from '../../core/events/toolbar.event';
import { FormBuilder, Validators } from '@angular/forms';
import { ContainerComponent } from '../../core/component/Container.Component';
import { Location } from '@angular/common';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { GenEnum } from '../shared/general.enum';
import { MenusService } from '../../core/service/menus.service';
@Component({
	selector: 'app-container',
	templateUrl: 'formcontainer.component.html'
})

export class AppContainerComponent extends ContainerComponent {

	menuid: number;
	@ViewChild('check') checked: ElementRef;
	dbname: any;
	id: any;
	screen: any;
	menucollection: any;
	jsoncollection: any = [];
	dbstxt: any;
	Tree: Array<any>;
	constructor(private toolbarEvent: ToolbarEvent,private menusService: MenusService, private fb: FormBuilder, public router: Router, public menuService: MenusService, private route: ActivatedRoute) {
		super();
		this.myForm = this.fb.group({});

	}
	// public modulename:any;
	// public screenname:any;
	moduletitile: any
	async ngOnInit() {

		this.moduletitile = this.localStorage.get('modulename')
		
		await this.getMenu();
		
	}


	async Back() {
		this.router.navigate(['home']);
		this.activatedRoute;
	}

	async dashboard(id) {
		

		let route: any = this.router;
		if (route && route.currentRouterState &&
			route.currentRouterState.snapshot &&
			route.currentRouterState.snapshot.root &&
			route.currentRouterState.snapshot.root.queryParams) {

			let data = route.currentRouterState.snapshot.root.queryParams;

			if (data && data.menuid && data.menucollection) {
				let jsonData = JSON.parse(data.menucollection);
				this.jsoncollection = jsonData;
				this.menuid = Number(data.menuid);

				let filterData = jsonData.filter(o => o.id === Number(data.menuid))[0];

				if (filterData && filterData.children) {
					let dashboardData = filterData.children.filter(o => o.menucatid === GenEnum.Menucategory.Dashboard)[0];

					if (dashboardData && dashboardData.children) {
						this.screen = dashboardData.children;

						if (id !== "") {
							this.dbstxt = id;
							var active = document.getElementById("mainmenu");
							active.classList.remove("activeclass");

							var element = document.getElementById("dashboardmenu");
							element.classList.add("activeclass");

							let navigationExtras: NavigationExtras = {
								queryParams: {
									menuid: Number(data.menuid),
									menucollection: JSON.stringify(this.jsoncollection)
								},
								replaceUrl: false
							};
							this.router.navigate([id], navigationExtras);
						}
					}
					else {
						console.log("Dashboard Does Not Exits");
					}
				}
			}
		}
	}
	async getMenu() {
		
		const dto = await this.menusService.getMenu();
		if (dto.IsSuccess) {
		  this.Tree = dto.Data;
		  if (this.Tree && this.Tree.length > 0) {
			this.Tree.forEach(async element => {
				
			  await this.getID(element.id)
			})
		  }
		  if (this.parentList.length > 0) {
			this.parentList.forEach(element => {
				
			  element.children.forEach(x => {
				if (element.id === x.parentid) {
				  x.parentId = element.parentId;
				  this.itemList.push(x);
				}
			  });
			})
		  }
		}
	}
  itemList = [];
  parentList = [];
  childerList = [];
  async getID(id) {
    if (id) {
      let jsonData = JSON.parse(JSON.stringify(this.Tree));
      let filterData = jsonData.filter((o) => o.id === Number(id))[0];
	  if(id === 1000015571){
		filterData.children.forEach(element => {
			element.parentId = id
			return this.parentList.push(element);
		  });
	  }
      
      
    }

  }
  routeid: any;
  onSuggestionClick(screen) {
    if (this.Tree && this.Tree.length > 0) {
      let obj = this.Tree.find(x => x.id === screen.parentId)
      if (obj) {
        this.routeid = screen.controllerId;
        let screenName = screen.label;
        let parentid = obj.id;
        let parentLable = obj.label;
        let navigationExtras: NavigationExtras = {
          queryParams: {
            menuid: parentid
          },
          replaceUrl: false
        };
        let modulename = this.localStorage.get('modulename')
        let screenname = this.localStorage.get('screenname')
        if (modulename || screenname) {
          this.localStorage.remove('modulename');
          this.localStorage.remove('screenname');
        }
        this.localStorage.set('modulename', parentLable);
        this.localStorage.set('screenname', screenName);
        return this.router.navigate([this.routeid], navigationExtras);
      }

    }
  }
	// async menucolloninit() {
	
	// 	this.menuid = 1000015571;
	// 	this.menucollection = [{ "id": 1000015571, "label": "Dashboard", "indx": 1, "controllerId": "", "webicon": "fa fa-tachometer", "menucatid": 24, "children": [{ "id": 1000015575, "label": "Dashboard", "parentid": 1000015571, "indx": 1, "webicon": "", "menucatid": 24, "children": [{ "id": 1000015576, "label": "Attendance Dashboard", "parentid": 1000015575, "indx": 1, "actions": ["create", "update", "delete", "view"], "controllerId": "Attendance", "webicon": "", "menucatid": 24, "children": [], "utdocsubtypeassign": { "Id": 312, "controllerid": "Attendance", "stxt": "Attendance Dashboard", "utdocsubtypemsgconfigdtls": [], "PrimaryKeyValue": 312 }, "assignid": 312, "menusubdtls": [] }, { "id": 1000015577, "label": "Revenue ", "parentid": 1000015575, "indx": 2, "actions": ["create", "update", "delete", "view"], "controllerId": "Revenue", "webicon": "", "menucatid": 24, "children": [], "utdocsubtypeassign": { "Id": 462, "controllerid": "Revenue", "doctypeid": 1000000733, "docsubtypeid": 10002500, "stxt": "Revenue", "utdocsubtypesetup": { "docsubtypecode": "030102", "docsubtypedesc": "Revenue", "utdocsubtypemsgconfigdtls": [], "PrimaryKeyValue": 0 }, "utdocsubtypemsgconfigdtls": [], "PrimaryKeyValue": 462 }, "assignid": 462, "menusubdtls": [] }, { "id": 1000015578, "label": "Campus Dashboard", "parentid": 1000015575, "indx": 3, "actions": ["create", "update", "delete", "view"], "controllerId": "HeadOfficeDashboard", "webicon": "", "menucatid": 24, "children": [], "utdocsubtypeassign": { "Id": 390, "controllerid": "HeadOfficeDashboard", "stxt": "Head Office Dashboard", "utdocsubtypemsgconfigdtls": [], "PrimaryKeyValue": 390 }, "assignid": 390, "menusubdtls": [] }, { "id": 1000015821, "label": "Exam Dashboard", "parentid": 1000015575, "indx": 5, "actions": ["create", "update", "delete", "view"], "controllerId": "ExamDashboard", "webicon": "", "menucatid": 24, "children": [], "utdocsubtypeassign": { "Id": 356, "controllerid": "ExamDashboard", "stxt": "Exam Dashboard", "utdocsubtypemsgconfigdtls": [], "PrimaryKeyValue": 356 }, "assignid": 356, "menusubdtls": [] }], "menusubdtls": [] }], "menusubdtls": [] }];
	// 	if (this.menuid != undefined) {
	// 		this.menuid = Number(this.menuid);
	// 		if (this.menucollection) {
	// 			if (this.menuid !== undefined && this.menucollection !== undefined) {

	// 				let filterData = this.menucollection.filter(o => o.id === Number(this.menuid))[0];
	// 				if (filterData && filterData.children) {
	// 					let dashboardData = filterData.children.filter(o => o.menucatid === 24)[0];
	// 					if (dashboardData && dashboardData.children) {
	// 						this.menuService.dashboards = dashboardData.children;

	// 					}
	// 				}
	// 			}
	// 		}
	// 	}

	// }

	Menu() {

		this.dbstxt = "";

		var active = document.getElementById("mainmenu");
		active.classList.add("activeclass");

		var dbmenu = document.getElementById("dashboardmenu");
		dbmenu.classList.remove("activeclass");

		if (this.menucollection) {

			let navigationExtras: NavigationExtras = {
				queryParams: {
					menuid: this.menuid,
					menucollection: JSON.stringify(this.menucollection)
				},
				replaceUrl: false
			};
			this.router.navigate(['menuview'], navigationExtras);

		}
	}

} 



// WEBPACK FOOTER //
// ./src/app/shell/formcontainer/formcontainer.component.ts